import './assets/index.css';

import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById('root')
);
